module.exports = __webpack_public_path__ + "static/media/holland_zorggroep_logo.dd52033f.png";